import actionCreator from '../../../shared/decorators/actionCreator';
import recordForUndo from '../../../shared/decorators/recordForUndo';

import { REDUX_NAMESPACE } from './constants';

const ACTION_CREATORS = {
  /** Action Creators for Keyframe **/
  @recordForUndo()
  @actionCreator(REDUX_NAMESPACE)
  addKeyframe(transformElementId, frame) {
    return {
      frame,
      transformElementId,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  createKeyframe() {},

  @actionCreator(REDUX_NAMESPACE)
  deleteKeyframe(transformElementId, frame) {
    return {
      frame,
      transformElementId,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  updateKeyframe(transformElementId, frame, newFrame, transform) {
    return {
      frame,
      newFrame,
      transform,
      transformElementId,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  updateKeyframes(transformElementId, keyframes) {
    return {
      keyframes,
      transformElementId,
    };
  },

  /** Action Creators for Keyframe Set **/
  @recordForUndo()
  @actionCreator(REDUX_NAMESPACE)
  addKeyframeSet(
    transformElementId,
    frame,
    rootEndFrame,
    duration,
    transition,
  ) {
    return {
      duration,
      frame,
      rootEndFrame,
      transformElementId,
      transition,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  createKeyframeSet() {},

  @actionCreator(REDUX_NAMESPACE)
  deleteKeyframeSet(transformElementId, setId) {
    return {
      setId,
      transformElementId,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  unpairKeyframeSet(transformElementId, setId) {
    return {
      setId,
      transformElementId,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  updateKeyframeSet(transformElementId, setId, startFrame, newStartFrame) {
    return {
      newStartFrame,
      setId,
      startFrame,
      transformElementId,
    };
  },

  @recordForUndo()
  @actionCreator(REDUX_NAMESPACE)
  setBlur(blurRadius, transformElementId, currentFrame) {
    return {
      blurRadius,
      transformElementId,
      currentFrame,
    };
  },
};

export default ACTION_CREATORS;
